export default {
  name: 'managerrequest',
  data () {
    return {
      label: 'MANAGER REQUEST',
      componentValue: this.value
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    componentValue: function () {
      this.$emit('input', this.componentValue)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/managerrequest/script.js